import { type ReactNode, useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import Sidebar from "./Sidebar"
import NotificationBell from "./NotificationBell"

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const mainRef = useRef<HTMLElement>(null)
  const { pathname } = useLocation()

  // Scroll main content to top on route change (not the sidebar)
  useEffect(() => {
    mainRef.current?.scrollTo(0, 0)
  }, [pathname])

  return (
    <div className="flex h-screen bg-slate-50 text-slate-900 overflow-hidden">
      <Sidebar />
      <main ref={mainRef} className="flex-1 overflow-y-auto">
        <div className="max-w-7xl mx-auto px-6 py-8">{children}</div>
      </main>
      {/* Floating admin bell — polls /admin/dashboard/notifications every 60s */}
      <NotificationBell />
    </div>
  )
}
